import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { BACKEND_URL } from "../lib/api";
import { Logo } from "../components/Logo";
import { CheckCircle2, XCircle } from "lucide-react";

const Unsubscribe = () => {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [status, setStatus] = useState("loading"); // loading | ok | error
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Link non valido.");
            return;
        }
        (async () => {
            try {
                const r = await fetch(`${BACKEND_URL}/api/unsubscribe?token=${encodeURIComponent(token)}`);
                if (r.ok) {
                    setStatus("ok");
                    setMessage("Le tue preferenze sono state aggiornate. Non riceverai più questo tipo di email.");
                } else {
                    setStatus("error");
                    setMessage("Il link non è valido o è scaduto.");
                }
            } catch {
                setStatus("error");
                setMessage("Errore di connessione.");
            }
        })();
    }, [token]);

    return (
        <div className="min-h-screen bg-bg flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-md text-center">
                <Link to="/" className="flex justify-center mb-8"><Logo /></Link>
                <div className="bg-paper rounded-2xl border border-border-line soft-shadow-lg p-8">
                    {status === "loading" && <div className="text-muted">Aggiornamento preferenze…</div>}
                    {status === "ok" && (
                        <>
                            <CheckCircle2 size={48} className="text-bordeaux mx-auto mb-4" />
                            <h1 className="font-heading text-3xl text-ink mb-2">Disiscrizione completata</h1>
                            <p className="text-sm text-muted">{message}</p>
                        </>
                    )}
                    {status === "error" && (
                        <>
                            <XCircle size={48} className="text-soft mx-auto mb-4" />
                            <h1 className="font-heading text-3xl text-ink mb-2">Ops</h1>
                            <p className="text-sm text-muted">{message}</p>
                        </>
                    )}
                    <Link to="/settings" className="btn-outline text-sm mt-6 inline-flex">Apri le impostazioni</Link>
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
